"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class PulseErrorEvent {
    constructor(message, httpStatus, messageVisibility) {
        this._message = message;
        this._httpStatus = httpStatus;
        this._messageVisibility = messageVisibility;
    }
    get message() {
        return this._message;
    }
    get httpStatus() {
        return this._httpStatus;
    }
    get messageVisibility() {
        return this._messageVisibility;
    }
}
exports.PulseErrorEvent = PulseErrorEvent;
//# sourceMappingURL=PulseErrorEvent.js.map